import React from 'react';
import { useForm } from 'react-hook-form';

export type LoginFormValues = {
    password: string;
};

export const useLoginStep = (onLoginSubmit: (password: string) => void) => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<LoginFormValues>();

    const [showPassword, setShowPassword] = React.useState(false);

    const toggleShowPassword = React.useCallback(
        () => setShowPassword((s) => !s),
        [],
    );

    const onSubmit = handleSubmit((data) => {
        onLoginSubmit(data.password);
    });

    return { register, errors, showPassword, toggleShowPassword, onSubmit };
};
